import React, { useContext, useEffect, useState } from 'react'
import { NewsInterface, ShowNewsContext, imageFormatsAllowed, videoFormatsAllowed } from './types';
import { hostName } from '../../requestMethods';
import { FaChevronCircleLeft, FaChevronCircleRight, FaTrash } from 'react-icons/fa';
import { InputImages } from '../../HtmlComponents/InputImages';
import { AddNewsPhotoApi } from '../../redux/news/newsApiCalls';
import { useDispatch } from 'react-redux';
import { Timeout } from '../../functions/functions';
import ShowErrorMsg from '../../HtmlComponents/ShowErrorMsg';

interface props {
  actuality: NewsInterface
}

const ToggleImages:React.FC<props> = ({ actuality }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToNextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % actuality.images.length);
  };

  const goToPrevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + actuality.images.length) % actuality.images.length);
  };

  const { setShowSuccessMsg, showDeleteNewsPhotoModal, setShowDeleteNewsPhotoModal, setSelectedPhoto, setSelectedNews } =  useContext(ShowNewsContext)

  const [images, setImages] = useState<File[] | any>(null)

  const dispatch: any = useDispatch()
  const [errors, setErrors] = useState([])

  useEffect(() => {
    if(images) {
      const handleSubmit = async () => {
        const formData: any = new FormData()
  
        for (let i = 0; i < images.length; i++) {
          formData.append("images", images[i]);
        }

        const response: any = await dispatch(AddNewsPhotoApi(actuality._id, formData))
        if(response === true) {
          setImages(null)
          setShowSuccessMsg(true)
          setTimeout(() => setShowSuccessMsg(false), Timeout)
        } else {
          setErrors(response)
        }
      }
      handleSubmit()
      setImages(null)
    }
  }, [images, actuality, dispatch, setShowSuccessMsg])

  const toggleDeletePhotoModal = (img: string) => {
    setShowDeleteNewsPhotoModal(!showDeleteNewsPhotoModal)
    setSelectedPhoto(img)
    setSelectedNews(actuality)
  }

  const [currentImage, setCurrentImage] = useState<any>()

  useEffect(() => {
    actuality.images[currentIndex] ? setCurrentImage(actuality.images[currentIndex]) : setCurrentImage(actuality.images[0])
  }, [actuality, currentIndex])

  return (
    <div>
    {currentImage && 
      <>
        <ShowErrorMsg errors={errors} setErrors={setErrors} />
        <div className="flex justify-between items-center">
          <FaChevronCircleLeft style={{ fontSize: "30px" }} className="text-main" onClick={goToPrevSlide}/>
          <section className='relative'>
            {imageFormatsAllowed.includes(currentImage.split(".")[1]) && 
              <img className='w-80 h-80' src={hostName + "imgs/News/" + currentImage} alt={`img ${currentIndex + 1}`} />
            }
            {videoFormatsAllowed.includes(currentImage.split(".")[1]) &&
              <video className='w-80 h-80' id="myVideo" controls>
                <source src={hostName + "imgs/News/" + currentImage} type={`video/${currentImage.split(".")[1]}`} />
              </video>
            }
            <div onClick={() => toggleDeletePhotoModal(currentImage)}>
              <FaTrash style={{ fontSize: "30px" }} className="text-red absolute top-1 right-1 bg-slate-200 rounded-full p-1" />
            </div>
          </section>
          <FaChevronCircleRight style={{ fontSize: "30px" }} className="text-main" onClick={goToNextSlide}/>
        </div>
        <form encType="multipart/form-data">
          <InputImages name="photos" setImages={setImages} accept="image/*" />      
        </form>
      </>
    }
    </div>
  )
}

export default ToggleImages